module.exports = __webpack_public_path__ + "img/custom_bg2.bd0a9c5c.png";